import BaseModel from "./BaseModel";
import UseStoreHandler from "@/composables/handlers/UseStoreHandler";

/**
 * Category
 */
export default class Category extends BaseModel{

  constructor({
    id,
    name,
    en,
    pt,
    es,
    total
  }) {
    super();

    this.id = id || null;
    this.name = name || null;
    this.en = en || null;
    this.pt = pt || null;
    this.es = es || null;
    this.total = total || 0;

    this.allowedLangs = ['en','pt','es'];
  }

  /**
   * Gets translated category name
   * @returns {String}
   */
  getTranslatedName() {
    const lang = UseStoreHandler.getContextStore().getLang;
    return this[lang] || this.en;
  }
}